<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Motivos de atendimento </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <div>
        <input [formControl]="formInput" type="text" class="form-input w-64" placeholder="Pesquise por Nome" />
      </div>
      <div class="flex justify-between">
        <button (click)="listReasons()" title="Filtrar Dispositivos" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button (click)="cleanForm()" title="Limpar Filtros" class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine">
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>

      </div>
    </div>
  </div>

  <app-list-reasons
    [reasons]="reasons"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="listReasons()"
  ></app-list-reasons>

  <hr class="mb-8" />

  <app-add-new-reason (reloadReasons)="listReasons()"></app-add-new-reason>
</form>
